export class Position {
    public top: number;
    public left: number;
    public width: number;
    public height: number;

    constructor() {
        this.top = 0;
        this.left = 0;
        this.width = 0;
        this.height = 0;
    }
}

export class ElementPosition {

    // eslint-disable-next-line
    public static getPosition (element: any): Position | null {
        const position = new Position();
        // if (element) {
        //     const elementInfo = element.getBoundingClientRect();
        //     position.top = elementInfo.top;
        //     position.left = elementInfo.left;
        //     position.width = elementInfo.width;
        //     position.height = elementInfo.height;
        //     return position;
        // }
        return null;
    }

}
